/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './ruleset-list-page.component.html';

import {LocalUserProfile} from '../../components/session/local-user-profile';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../common/controller/signal-admin-resource-list-state';
import {RulesetApiService, RulesetModel} from './ruleset-api.service';
import {APP_SHARED} from '../common/app-shared';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-ruleset-list-page',
  template
})
export class RulesetListPageComponent implements OnInit {
  readonly itemStateName = 'app.inv.rulesets.ruleset';
  showTeamColumn = false;

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'},
    {param: 'floorPrice'},
    {label: 'advertiserExceptions', param: '', sortable: false}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<RulesetModel>(
    inject(RulesetApiService),
    {listId: 'fullRulesetList'},
    inject(DestroyRef)
  );

  constructor(localUserProfile: LocalUserProfile) {
    const username = localUserProfile.get('username');
    if (username === 'adnuntius@adnuntius.com' || username === 'broker1@adnuntius.com') {
      this.showTeamColumn = true;
      this.columns = this.columns.concat({param: 'team'});
    }
  }

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
